import { Suspense, useContext } from 'react';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { ExternalSearchInTransit } from '~/apps/smartsend/lib/consts/ListyConsts';
import Listy from '~/apps/smartsend/components/smartsend/listy/Listy';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import useGoto from '~/hooks/use-goto';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { goTo } = useGoto();
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.MYORDERS);

  useOnLoad(() => {
    const title = t('INTRANSIT_PAGE_TITLE', { defaultValue: 'Orders InTransit' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.MYORDERS });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: {
        title: title,
        currentPageRoute: RoutingConstants.InTransit,
        showSmartActions: true
      }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.InTransit
      }
    });
  });

  return (
    <Tagged tag="screen-intransit">
      <Suspense>
        <Listy initialTab={ExternalSearchInTransit} isXs={isXs} goTo={goTo} />
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'SmartSend: Orders InTransit';
